/**
 * In-tree Labs domain bundles. Employment lives in TalentCo / Recruitr Tech packs.
 */
import type { TenantPluginRegister } from '@/plugin/types'

export const DOMAIN_BUNDLES: ReadonlyArray<readonly [string, TenantPluginRegister]> = []
